import { render } from "./TableHeadCell.vue?vue&type=template&id=95aa15d6"
import script from "./TableHeadCell.vue?vue&type=script&lang=js"
export * from "./TableHeadCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__